// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1656":"css/admin-app.6982","8816":"css/app.6982"}[chunkId] + ".css";
};